import React, { Fragment } from 'react'

const ItemPrint = ({ item }) => {
  return (
    <div className="container-print-grid">
      <div>{item.id}</div>
      <div>
        {item.lotteryId &&
          <Fragment>
            {item.isPrize
              ? item.lotteryId
              : <span className="item-not-prize-text">{item.lotteryId}</span>
            }
          </Fragment>
        }
      </div>
    </div>
  )
}

export default ItemPrint
